<template>
  <div class="resource-main">
    <div class="header">
      <h3>Documentation, videos, resources...</h3>
    </div>
    <div v-if="resources" class="content">
      <section class="navigate">
        <a-list item-layout="horizontal" :data-source="resources">
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta @click="selectContent(item)">
              <a slot="title"
                ><a-icon
                  v-if="item.type"
                  :type="icon(item.type)"
                  slot="avatar"
                />
                {{ item.title }}</a
              >
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </section>
      <section class="data">
        <div v-if="dataContent">
          <h2>{{ dataContent.title }}</h2>
          <iframe
            v-if="dataContent.url"
            width="640"
            height="640"
            :src="dataContent.url"
            frameborder="0"
            allowfullscreen
          />

          <div v-else>Oops, something went wrong!</div>
        </div>
        <div v-else>
          <h2>Choose your topic</h2>
        </div>
      </section>
    </div>
    <div v-else class="content">
      <a-spin size="large" />
    </div>
    <div class="footer" />
  </div>
</template>

<script>
import { getResources } from "@/api/resource";

import axios from "@/api/index";
import { tokenRequest } from "@/config/authConfig";
export default {
  data: function() {
    return {
      dataContent: null,
      resources: null
      // [
      //   {
      //     title: "EOSCONNECT Core | Edition 11.21 new Features",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=3XLfHE_zos4phTSER2P3wx&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=80000",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EOSCONNECT Core Introduction",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=EsjyUD86wrw9adctpNiYYY&player-id=4rsz9yFAX3BJKEHWgX7ron&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "The EDN Portal manual",
      //     url:
      //       "./EOSDeveloperNetworkPortal_UserManual.pdf#toolbar=1&navpanes=0&scrollbar=0",
      //     type: "application/pdf",
      //     icon: "file-pdf"
      //   },
      //   {
      //     title: "EDN Portal - Introduction",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=AFdSTQifqC8VWgxh-6UkjV&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88618",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - Configure VPN",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=AQAYR3mrCzKikY28XKrhTS&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - Direct Connection",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=BzSSqZX6pNPQ6vtX2sk-UD&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - EOSPRINT2 and hosts file",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=Af5A2cSuNyJH4_PAq46eHU&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - PLCSIM for EOS M 300-4",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=DUTk4WT2aCTFUMrGua-ghK&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - RDP using VPN",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=CjRMcnLwjEZqQokt1_vZk1&player-id=4rsz9yFAX3BJKEHWgX7ron&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - Starting a build job",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=9uEunGHLxCtNoUqnCPBYQV&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - User guide",
      //     url:
      //       " https://e.video-cdn.net/share?video-id=6_cizPpTDxjMqjaqVBFSC8&player-id=4rsz9yFAX3BJKEHWgX7ron&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - Using VNC",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=3yEXxMZckptwBvuSDxMCuz&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88421",
      //     icon: "play-square"
      //   },
      //   {
      //     title: "EDN - EOSPRINT Server",
      //     url:
      //       "https://e.video-cdn.net/share?video-id=9aCryBJPmuP1o_cw2j-37Z&player-id=EdkHpUNtj_rUYsPC8cJkgD&channel-id=88421",
      //     icon: "play-square"
      //   }
      // ]
    };
  },
  methods: {
    selectContent(item) {
      this.dataContent = item;
    },
    icon(type = "general") {
      const lowerType = type.toLowerCase();
      switch (lowerType) {
        case "video":
          return "play-square";
        case "pdf":
          return "file-pdf";
        case "general":
        default:
          return "play-square";
      }
    },
    async getResources() {
      try {
        const resources = await getResources();

        this.resources = resources.data.data.sort((a, b) => {
          const aTitle = a.title.toLowerCase();
          const bTitle = b.title.toLowerCase();
          if (aTitle < bTitle) return -1;
          if (aTitle > bTitle) return 1;
          return 0;
        });
      } catch (error) {
        this.$notification.error({
          message: error.message || "Could not fetch user token!",
          description: "Unable to retrieve resources."
        });
      }
    },
    async getToken() {
      try {
        const userData = await this.$msal.acquireToken(tokenRequest);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${userData.accessToken}`;
      } catch (error) {
        this.$notification.error({
          message: error.message || "Could not fetch user token!",
          description: "Unable to retrieve resources."
        });
      }
    }
  },
  async mounted() {
    await this.getToken();
    await this.getResources();
  }
};
</script>
<style scoped lang="scss">
@import "../styles/_variables.scss";
.resource-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  background-color: $backgroundColor;
}
.header {
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 32px;
  background-color: #ffffff;
  & h3 {
    color: #e60010;
    font-size: 24px;
    font-weight: 400;
    margin: 0;
  }
}
.content {
  display: flex;
  flex-direction: row;
  align-content: center;
  flex-wrap: nowrap;
  width: 60%;
  min-height: 640px;
}
.navigate {
  padding: 1rem;
  flex: 1;
  align-items: flex-start;
  background-color: white;
  li {
    align-content: flex-start;
    text-align: left;
    a {
      margin-left: 1rem;
    }
    i {
      margin-right: 4px;
    }
  }
}

.data {
  padding: 1rem;
  background-color: white;
  flex: 2;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
}

.footer {
  margin-top: 2rem;
  flex: 1;
  background-color: white;
  width: 100%;
}
</style>
